import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface OrderConditionReadOnlyFieldProps {
  label: LangEnum;
  value?: string;
  adornment?: ReactNode;
}

const OrderConditionReadOnlyField = ({
  label,
  value,
  adornment,
}: OrderConditionReadOnlyFieldProps) => {
  const { translate } = useTranslation();

  return (
    <Stack sx={{ gap: 0.25, minWidth: 0 }}>
      <Typography variant="micro1" sx={{ color: 'text.secondary' }}>
        {translate(label)}
      </Typography>
      <Stack direction="row" sx={{ gap: 0.5, alignItems: 'center', minWidth: 0 }}>
        <Typography variant="body2" sx={{ color: value ? 'text.primary' : 'text.disabled' }}>
          {value || translate(LangEnum.GLOBAL_NO_INFORMATIONS)}
        </Typography>

        {adornment}
      </Stack>
    </Stack>
  );
};

export default OrderConditionReadOnlyField;
